import { logger } from "../utils";

export const getSafeStorage = () => {
  if (typeof window === "undefined") {
    return {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    };
  }

  try {
    return (
      window.localStorage ?? {
        getItem: () => null,
        setItem: () => {},
        removeItem: () => {},
      }
    );
  } catch (e) {
    logger.warn("⚠️ LocalStorage unavailable:", e);
    return {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    };
  }
};
